import { Grid } from '@material-ui/core';
import { Button, DateField, StandardDialog, TextField } from '@roc/ui';
import { format } from 'date-fns';
import { isValid } from 'date-fns/esm';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

interface IMarkAsPaidModalProps {
  payableRefNumber: string;
  showMarkAsPaidModal: boolean;
  setPayableRefNumber: (value) => void;
  handleMarkAsPaidConfirm: () => void;
  closeMarkAsPaidModal: () => void;

}

export const MarkAsPaidModal = observer(({ payableRefNumber, setPayableRefNumber, showMarkAsPaidModal, closeMarkAsPaidModal, handleMarkAsPaidConfirm }: IMarkAsPaidModalProps) => {

  const [formattedDate, setFormattedDate] = useState(null)

  const manageDate = newDate => {
    const newFormattedDate = isValid(newDate) ? format(newDate, 'MM/dd/yyyy') : null;
    setFormattedDate(newFormattedDate);
  };

  useEffect(() => {
    if (showMarkAsPaidModal) setFormattedDate(format(new Date(), 'MM/dd/yyyy'))
  }, [showMarkAsPaidModal])
  useEffect(() => {
    setPayableRefNumber(formattedDate)
  }, [formattedDate])

  const getContent = () => {
    return (
      <Grid container>
        <Grid item xs={12}>
          <DateField
            label={"Paid Date"}
            testId="paid-formatted-date"
            format="MM/dd/yyyy"
            inputVariant="outlined"
            standaloneLabel
            fullWidth
            value={formattedDate}
            onChange={newDate => manageDate(newDate)}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <StandardDialog
      open={showMarkAsPaidModal}
      title={"Mark as Paid"}
      maxWidth="sm"
      handleClose={closeMarkAsPaidModal}
      dialogContent={
        getContent()
      }
      dialogActions={(
        <>
          <Button
            style={{ marginRight: '8px' }}
            onClick={closeMarkAsPaidModal}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={handleMarkAsPaidConfirm}
            color="primary"
            variant="contained"
            testId="confirm"
            disabled={!payableRefNumber}
          >
            Confirm
          </Button>
        </>
      )}
    />
  );

});
